module.exports = __webpack_public_path__ + "img/nav-return.30cb8209.svg";